import { Nullable } from 'types';

export const joinStrings = (
  values: Nullable<string>[],
  separator: string,
  placeholder: string | null = '-'
): string => {
  const data = values.filter((value) => value && value?.length > 0) as string[];
  return data.length === 0 ? (placeholder ?? '') : data.join(separator);
};

export const clearCacheAndReload = async () => {
  const keyList = await caches.keys();
  await Promise.all(keyList.map((key) => caches.delete(key)));

  window.location.reload();
};
